/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-11-02 14:05:19
 * @LastEditors: zhangcongcong zhangcongcong@move2newidea.com
 * @LastEditTime: 2023-12-15 14:28:59
 * @FilePath: /memo-web/src/modules/memos.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as apis from "../api/networkDisk";
import { fileraw } from "../api/file";
import { StorageModule } from "./storage";
import { SocketModule } from "./socket";
import { message } from "antd";
import axios from "axios";
// import { getImage } from "../util";
import { deepCopy } from "../util";

let inter = ""; // 定时器
// import useStore from '../store/useStore'

// const { store, dispatch } = useStore();

export const memosModule = {
  // 获取详情
  getDetail(id) {
    return new Promise(async (resolve, reject) => {
      let res = await apis.getExcellingTopic(id);
      console.log("2res", res);
      if (res?.data) {
        res.data.memos.map((i, index) => {
          i.$operate$ = "save";
        });
        res.data.relationBelongTos.map((i, index) => {
          i.$operate$ = "save";
        });
        res.data.comments.map((i, index) => {
          i.$operate$ = "save";
        });
        let subjectInfo = {
          subjectId: res.data.id,
          subjectTitle: res.data.subject,
          subjectCatalogue: res.data.catalogue,
          total: res.data.memos.length,
          data: res.data,
          catalogueId: res.data.catalogueInfo,
          permissions: res.data.permissions,
        };
        window.appdispatch({ type: "SET_SUBJECTINFO", data: { ...subjectInfo } });
        resolve(res);
      } else {
        reject(res);
      }
    });
  },
  /**
   * 操作讨论组成员
   */
  operationMan(users, type, data) {
    let params = deepCopy(data);
    params.$operate$ = "save";
    //增量传值，所以将memos、comments、relationBelongTos置空
    params.memos = [];
    params.comments = [];
    params.relationBelongTos = [];
    params.userInfos = [];
    if (type === "add") {
      params.users = params.users.concat(users);
    } else if (type === "deleteAll") {
      params.users = [];
    } else if (type === "delete") {
      params.users = params.users.filter((i) => i != users);
    }
    memosModule.saveSubject(data.id, params);
  },
  /**
   *
   * @param params 保存主题
   */
  saveSubject(id, params) {
    return new Promise(async (resolve, reject) => {
      let res = await apis.putExcellingTopic(id, params);
      console.log('saveSubject',res,id)
      if (res?.data) {
        resolve(res);
      } else {
        reject("error");
      }
    });
  },
};
